import { Controller } from "@hotwired/stimulus"

// data-controller="autoscroll"
// Scrolls its element into view shortly after it renders. Used on validation
// error banners: when a form submission returns 422, Turbo re-renders the page
// and resets scroll to the top, leaving an error in a lower section below the
// fold. The requestAnimationFrame defers the scroll until after Turbo's reset.
export default class extends Controller {
  connect() {
    this.frame = requestAnimationFrame(() => {
      this.element.scrollIntoView({ behavior: "smooth", block: "center" })
    })
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }
}
